import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FlexContainer } from '../../styled/layout.styled';

const StyledIconContainer = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background-color: #f8f5ff;
  img {
    margin: 8px;
  }
`;

const StyledP = styled.p`
  color: ${({ theme }) => theme.color.white};
  margin: 0;
`;

const Card = ({
  image, title, description, alt,
}) => (
  <FlexContainer alignItems="center" padding="0 0 24px 0">
    <StyledIconContainer alignItems="center">
      <img src={image} alt={alt} />
    </StyledIconContainer>
    <FlexContainer margin="0 0 0 16px" flexDirection="column">
      <StyledP className="bold">{title}</StyledP>
      <StyledP>{description}</StyledP>
    </FlexContainer>
  </FlexContainer>
);

Card.propTypes = {
  image: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

export default Card;
